import {useState, useEffect } from 'react'
import axios from 'axios'
import { useToast } from "../../toastHook"
import moment from 'moment'
import { download } from '../../utils/download'

export const MissingCompetenceComponent = () => {
    const { display } = useToast();

    const [lastCalculation, setLastCalculation] = useState();
    const [doOnce, setDoOnce] = useState(false);

    useEffect(() => {

        axios.get("/api/missingcompetence/last")
            .then(response => {
                if (response.status === 200 && response.data) {
                    setLastCalculation(response.data);
                }
            })


    });


    const launchCalculAction = () => {

        if (doOnce) {
            return;
        }

        setDoOnce(true);

        axios.get("/api/missingcompetencejob/calculate")
            .then(
                response => {
                    display({
                        titre: 'le calcul a démarré',
                        text: `le  calcul a démarré, veuillez rafraîchir la page dans 10 min`,
                        severity: 'success'
                    });
                }
            )
    }

    var calculatedHtml = <></> 
    if (lastCalculation) {
        calculatedHtml = <div>
            <h5>Dernier calcul {moment(lastCalculation).format('LL')}</h5>
            <button className="btn btn-outline-primary" onClick={() => download('/api/missingcompetence/export', 'missing_competences' + moment(lastCalculation).format('YYYYMMDD') + '.xlsx' )}  >Télecharger les résultats</button>
        </div>
    }

    return <div>
        <div className="alert alert-info">Vous trouverez ici les consultants qui ont mis des compétences niveau supérieurs à 3 mais ne les ont pas dans les expériences de leurs derniers cv
            <br />
            Vous trouverez aussi les consultants qui ont remplis leurs cv mais n'ont pas assignés les compétences.
            <br /> <button onClick={launchCalculAction} className="btn btn-outline-primary">cliquez ici pour lancer un calcul</button>
        </div>
        {calculatedHtml }
        </div>
}





